const IconStarGrey = ({ size, width, height, ...props }) => (
    <svg
        width={width || size}
        height={height || size}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.34766 0.75C7.62109 0.75 7.83984 0.914062 7.94922 1.13281L9.83594 4.98828L14.0195 5.61719C14.2656 5.64453 14.457 5.83594 14.5391 6.05469C14.6211 6.30078 14.5664 6.54688 14.375 6.73828L11.3398 9.74609L12.0508 13.9844C12.1055 14.2305 11.9961 14.5039 11.8047 14.6406C11.5859 14.7773 11.3125 14.8047 11.0938 14.6953L7.34766 12.6719L3.60156 14.6953C3.38281 14.8047 3.13672 14.7773 2.91797 14.6406C2.72656 14.5039 2.61719 14.2305 2.64453 13.9844L3.38281 9.74609L0.347656 6.73828C0.15625 6.54688 0.101562 6.30078 0.183594 6.05469C0.265625 5.83594 0.457031 5.64453 0.703125 5.61719L4.88672 4.98828L6.77344 1.13281C6.88281 0.914062 7.10156 0.75 7.34766 0.75ZM7.34766 2.91016L5.92578 5.89062C5.81641 6.08203 5.65234 6.21875 5.43359 6.24609L2.17969 6.71094L4.53125 9.03516C4.69531 9.19922 4.75 9.41797 4.72266 9.63672L4.17578 12.8906L7.04688 11.3594C7.23828 11.25 7.48438 11.25 7.67578 11.3594L10.5469 12.8906L10 9.63672C9.94531 9.41797 10.0273 9.19922 10.1914 9.03516L12.5156 6.71094L9.28906 6.24609C9.07031 6.21875 8.87891 6.08203 8.79688 5.89062L7.34766 2.91016Z"
            fill="#999999"
        />
    </svg>
);

export default IconStarGrey;
